module.exports = __webpack_public_path__ + "static/waterproof-mattress-protector-1-85047605c28b682ada9b64c96037be65.mp4";